module.exports = __webpack_public_path__ + "static/media/liten.a0441305.m4a";